import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setLogged, is_out, changeStatus } from '../../../modules/actions/Login'
import { openModal, closeModal } from '../../../modules/actions/Modais'

import T from '../../../SPRINTA/translate/T'

import TopbarS from '../../../SPRINTA/Topbar'

class Topbar extends Component {
  state = {
    language: null
  }

  componentWillMount() {
    T.handleUpdate(language => {
      this.setState({
        language
      })
    })
  }
  
  handleLogin( response ) {
   

    if(response.status && response.status === 'done' && !response.data.errors)
      if(response.logged) {
        this.props.setLogged(response.data, response.authorization)
        //corrige se usar cookie
        // localStorage.setItem('authorization', response.authorization)
      } else
        this.props.is_out()

    if(response.status === 'done')
      this.props.changeStatus(response.status)
    
  }

  render() {
    return (
      <TopbarS
          language={this.state.language}
          isLogged={this.props.loginData.isLogged}
          handleLogin={ response => this.handleLogin( response ) }
          modalOpened={ this.props.modais.modalOpened }
          handleModalClose={ (ref) => { this.props.closeModal(ref) } }
          config={{
            URL_API: window.URL_API,
            URL_BASE: window.URL_BASE,
            URL_CHECKOUT: window.config.url_checkout,
          }}
        />
    )
  }
}

const mapStateToProps = state => ({
  loginData: state.login,
  modais: state.modais
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setLogged,
  is_out,
  openModal,
  closeModal,
  changeStatus
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Topbar)


// WEBPACK FOOTER //
// ./src/components/organisms/Topbar/index.js